<header class="header" [class.menu-open]="isMenuOpen">
  <!-- <div class="top-header">
    <p class="subtitle">SpeakOut Wireless</p>
    <div class="combined">
      <p class="subtitle grey">Merch</p>
      <p class="caption grey">Soon</p>
    </div>
     <div class="combined">
      <p class="subtitle grey">Gift Cards</p>
      <p class="caption grey">Soon</p>
    </div>
  </div> -->
  <div class="black-header">
    <p class="caption">Deal of the month: go annual and save versus monthly.</p>
  </div>
  <div class="header-inner">
    <button class="header-hamburger" aria-label="Toggle navigation" type="button" (click)="toggleMenu()">
      <span></span>
      <span></span>
    </button>

    <div class="logo" (click)="goToStore()">
      <img src="/assets/img/blue-logo.avif" width="122" height="48" alt="logo">
    </div>

    <nav class="nav" [class.is-open]="isMenuOpen">
      <a class="nav-item" translate (click)="closeMenu()" [routerLink]="[accountRoute]">Account</a>
      <a class="nav-item" translate (click)="closeMenu()" [routerLink]="['/', topUpRoute]">Redeem Voucher</a>
      <a class="nav-item" translate (click)="closeMenu()" [routerLink]="['/', portRoute]">Switch to SpeakOut</a>
    </nav>

    <div class="header-actions">
      <button class="tertiary button" (click)="goToStore()">
       Back to Store
      </button>
    </div>
  </div>

  <div class="nav-backdrop" *ngIf="isMenuOpen" (click)="closeMenu()"></div>
</header>
